import { configureStore } from '@reduxjs/toolkit';
import creativeReducer from './slices/creativeSlice';
import mediaReducer from './slices/mediaSlice';
import socialResonanceReducer from './slices/socialResonanceSlice';
import aiMeasurementReducer from './slices/aiMeasurementSlice';
import topContentReducer from './slices/topContentSlice';
import authReducer from './slices/authSlice';
import agentChatReducer from './slices/agentChatSlice';
import influencerReducer from './slices/influencerSlice';

export const store = configureStore({
  reducer: {
    creative: creativeReducer,
    media: mediaReducer,
    socialResonance: socialResonanceReducer,
    aiMeasurement: aiMeasurementReducer,
    topContent: topContentReducer,
    auth: authReducer,
    agentChat: agentChatReducer,
    influencer: influencerReducer,
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
